import { VeriLiteInformationEvent, IVeriLiteEvent, IVeriLiteEventAction, IResources, VeriLiteEventAction, InputValidation, IValidation, InputValidationState, Validation } from '../../../../../Types';
import * as React from 'react';
import { InputGroup, InputGroupAddon, InputGroupText, Input, FormFeedback, Row, Col } from 'reactstrap';
import { Auth } from '../../../../../Services/AuthenticationService';
import { defaultPostOptions, UserRequestHeaders } from '../../../../../Services/Util';
import { Overlay, CustomSpinner } from '../../../../../Components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { EventHandlerProvider } from '../../../../../Services/EventHandlerService';


export function AddUserEvent(updateCallback: () => void, locations: any, resources: IResources, isSuperUser: boolean) {
    var addUserEventContentRef = React.createRef<AddUserEventContent>();

    return new VeriLiteInformationEvent(
        <AddUserEventContent ref={addUserEventContentRef} updateCallback={updateCallback} locations={locations} resources={resources} isSuperUser={isSuperUser}/>,
        resources.AddUserTitle,
        [
            new VeriLiteEventAction(
                 resources.SetupLocations_AddLocation,
                 "primary",
                 async (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                    addUserEventContentRef.current?.addUser();
                }
            ), new VeriLiteEventAction(
                 resources.Close,
                "secondary",
                 (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                    closeModalCallback();
                }
            )
        ]
    );
}



enum AddUserEventContentState {
    Initial,
    Pending,
    Success,
    Error
}

interface INewUser {
    [key: string]: string;
    AdminEmail: string;
    AdminDisplayName: string;
    DefaultLocation: string;
    UserRole: string;
}

interface INewUserValidation {
    [key: string]: InputValidation;
    AdminEmail: InputValidation;
    AdminDisplayName: InputValidation;
    DefaultLocation: InputValidation;
    UserRole: InputValidation;
}



const userRoles =(resources:IResources, isSuperUser:boolean) => {
    if (isSuperUser) {
        return [{
            key: "User",
            text: resources.User
        }, {
            key: "Administrator",
            text: resources.Administrator
        }, {
            key: "SuperUser",
            text: "SuperUser"
        }];
    }
    return [{
    key: "User",
    text: resources.User
}, {
    key: "Administrator",
    text: resources.Administrator
}] };

interface IAddUserEventContentState {
    UserData: INewUser,
    UserDataValidation: INewUserValidation;
    status: AddUserEventContentState;
    ApplicationValidation: Validation;
}

interface IAddUserEventContentProps {
    updateCallback: () => void;
    locations: any;
    resources: IResources;
    isSuperUser: boolean;
}

interface IRequestError {
    title: string;
    detail: string;
}

class AddUserEventContent extends React.Component<IAddUserEventContentProps, IAddUserEventContentState>{
    constructor(props: IAddUserEventContentProps) {
        super(props);

        this.state = {
            UserData: {} as INewUser,
            UserDataValidation: {
                AdminDisplayName: new InputValidation(true, props.resources.InvalidDisplayName, /^\S+.{1,}\S$/),
                AdminEmail: new InputValidation(true, props.resources.Registration_Validation_EmailIsNotValid, /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/),
                DefaultLocation: new InputValidation(),
                UserRole: new InputValidation()
            },
            status: AddUserEventContentState.Initial,
            ApplicationValidation: new Validation()
        };
    }

    error: IRequestError = {} as IRequestError;

    

    private clearValidation = () => {
        this.setState({
            UserDataValidation: {
                AdminDisplayName: this.state.UserDataValidation.AdminDisplayName.reset(),
                AdminEmail: this.state.UserDataValidation.AdminEmail.reset(),
                DefaultLocation: this.state.UserDataValidation.DefaultLocation.reset(),
                UserRole: this.state.UserDataValidation.UserRole.reset()
            }
        });
    };

    private validateInputs = (): boolean => {
        var validationData = this.state.UserDataValidation;

        validationData.AdminDisplayName.validate(this.state.UserData.AdminDisplayName);
        validationData.AdminEmail.validate(this.state.UserData.AdminEmail);
        validationData.DefaultLocation.validate(this.state.UserData.DefaultLocation);
        validationData.UserRole.validate(this.state.UserData.UserRole);
        this.setState({ UserDataValidation: validationData })

        return !validationData.AdminDisplayName.isInvalid() && !validationData.AdminEmail.isInvalid() && !validationData.DefaultLocation.isInvalid() && !validationData.UserRole.isInvalid();
    };
    
    private updateUserData = (event: React.ChangeEvent<HTMLInputElement>, propName: string) => {        
        this.setState({
            UserData: { ...this.state.UserData, [propName]: event.target.value }
        }, () => {
            this.setState({
                UserDataValidation: { ...this.state.UserDataValidation, [propName]: this.state.UserDataValidation[propName].validate(this.state.UserData[propName]) }
            });
        });
    };

    private updateValidation = (validationResponse: any) => {
        this.clearValidation();
        this.setState({ ApplicationValidation: { Error: validationResponse, State: InputValidationState.invalid } as Validation });
        //console.log("validationResponse");
        //console.log(validationResponse);
        //if (validationResponse.name == "SetupLocations_CannotAddDuplicateLocations") {
        //    this.setState({
        //        LocationNameValidationError: validationResponse.value,
        //        LocationNameValidationState: InputValidationState.invalid
        //    });
        //}
        //
        //if (validationResponse.name == "SetupLocations_CannotAddDuplicateClientId") {
        //    this.setState({
        //        ClientIdValidationError: validationResponse.value,
        //        ClientIdValidationState: InputValidationState.invalid
        //    });
        //}
    };

    addUser = async () => {
        this.clearValidation();
        if (!this.validateInputs()) {
            return;
        }
        var user: INewUser = this.state.UserData;

        this.updateModal(AddUserEventContentState.Pending);

        var options: RequestInit = {};

        options = Object.assign({ ...defaultPostOptions }, options);

        const json = JSON.stringify(user);
        options = { ...options, body: json };

        var userRequestHeaders = new UserRequestHeaders(Auth.getUser());
        var headers = new Headers(options.headers);

        await Auth.getAccessToken().then((token) => {
            headers.append("Authorization", `Bearer ${token}`);
            options.headers = headers;
        }).catch((error) => {
            console.error(`Error adding auth header: ${error}`);
        });

        userRequestHeaders.AppendHeaders(options);


        fetch(`/users/CreateUser`, options).then((response) => {
            //console.log(response);
            if (!response.ok) {
                switch (response.status) {
                    case 400:
                        //console.log("400");
                        this.updateModal(AddUserEventContentState.Initial);
                        response.json().then((validationResponse) => {
                            this.error.title = this.props.resources.Error;
                            this.error.detail = validationResponse;
                            this.updateModal(AddUserEventContentState.Error);

                        });
                        break;
                    case 402:
                        //console.log("402");
                        response.json().then((errorResponse) => {
                            this.error.title = errorResponse.title;
                            this.error.detail = errorResponse.detail;
                            this.updateModal(AddUserEventContentState.Error);
                        });
                        break;
                    case 500:
                        response.json().then((errorResponse) => {
                            this.error.title = errorResponse.title;
                            this.error.detail = errorResponse.detail;
                            this.updateModal(AddUserEventContentState.Error);
                        }).catch(() => {
                            this.error.title = this.props.resources.Error;
                            this.error.detail = this.props.resources.ServerErrorMessage;
                            this.updateModal(AddUserEventContentState.Error);
                        });
                        break;
                    default:
                        response.json().then((errorResponse) => {
                            this.error.title = errorResponse.title;
                            this.error.detail = errorResponse.detail;
                            this.updateModal(AddUserEventContentState.Error);
                        }).catch(() => {
                            this.error.title = this.props.resources.Error;
                            this.error.detail = this.props.resources.UnknownErrorMessage;
                            this.updateModal(AddUserEventContentState.Error);
                        });
                        break;
                }
            }
            else {
                this.updateModal(AddUserEventContentState.Success);
            }
        }).catch((err) => {
            console.error("Error adding new user:");
            console.error(err);
        });
    };

    private updateModal = (newState: AddUserEventContentState) => {
        this.setState({ status: newState });
        switch (newState) {
            case AddUserEventContentState.Success:
                this.props.updateCallback();
                var eventHandler = EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();

                event.title = this.props.resources.Success;
                event.actions = [
                    new VeriLiteEventAction(
                         this.props.resources.Finish,
                         "primary",
                         (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            closeModalCallback();
                        }
                    )
                ];

                eventHandler.UpdateEvent();
                break;

            case AddUserEventContentState.Error:
                var eventHandler = EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();

                event.title = this.error.title || this.props.resources.Error;
                event.actions = [
                    new VeriLiteEventAction(
                         this.props.resources.Close,
                         "secondary",
                         (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            closeModalCallback();
                        }
                    )
                ];

                eventHandler.UpdateEvent();
                break;

            case AddUserEventContentState.Pending:
                var eventHandler = EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();

                event.title = this.props.resources.LoadingDotDotDot;
                event.actions = [];

                eventHandler.UpdateEvent();
                break;

            case AddUserEventContentState.Initial:
                var eventHandler = EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();

                event.title = this.props.resources.AddUserTitle;
                event.actions = [
                    new VeriLiteEventAction(
                         this.props.resources.Add,
                         "primary",
                         async (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            this.addUser();
                        }
                    ), new VeriLiteEventAction(
                         this.props.resources.Close,
                         "secondary",
                         (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            closeModalCallback();
                        }
                    )
                ];

                eventHandler.UpdateEvent();
                break;
        }
    };

    stateBasedRender = (currentState: AddUserEventContentState): JSX.Element => {
        switch (currentState) {
            case AddUserEventContentState.Initial:
                return (<div>
                    <InputGroup className="my-3" >
                        <InputGroupAddon addonType="prepend" >
                            <InputGroupText>{this.props.resources.DisplayName}</InputGroupText>
                        </InputGroupAddon>
                        <Input valid={this.state.UserDataValidation.AdminDisplayName.isValid()} invalid={this.state.UserDataValidation.AdminDisplayName.isInvalid()} onChange={(e) => this.updateUserData(e, "AdminDisplayName")} value={this.state.UserData.AdminDisplayName} />
                        <FormFeedback style={{ textAlign: "right" }}>{this.state.UserDataValidation.AdminDisplayName.isInvalid() ? this.state.UserDataValidation.AdminDisplayName.Validation.Error : ""}</FormFeedback>
                    </InputGroup>
                    <InputGroup className="my-3" >
                        <InputGroupAddon addonType="prepend" >
                            <InputGroupText>{this.props.resources.Registration_Email}</InputGroupText>
                        </InputGroupAddon>
                        <Input valid={this.state.UserDataValidation.AdminEmail.isValid()} invalid={this.state.UserDataValidation.AdminEmail.isInvalid()} onChange={(e) => this.updateUserData(e, "AdminEmail")} value={this.state.UserData.AdminEmail} />
                        <FormFeedback style={{ textAlign: "right" }}>{this.state.UserDataValidation.AdminEmail.isInvalid() ? this.state.UserDataValidation.AdminEmail.Validation.Error : ""}</FormFeedback>
                    </InputGroup>
                    <InputGroup className="my-3" >
                        <InputGroupAddon addonType="prepend" >
                            <InputGroupText>{this.props.resources.DefaultLocation}</InputGroupText>
                        </InputGroupAddon>
                        <Input type={"select"} valid={this.state.UserDataValidation.DefaultLocation.isValid()} invalid={this.state.UserDataValidation.DefaultLocation.isInvalid()} onChange={(e) => this.updateUserData(e, "DefaultLocation")} value={this.state.UserData.DefaultLocation}>
                            <option key="default" hidden>
                                {this.props.resources.PleaseSelectALocation}
                            </option >
                            {
                                this.props.locations.map((location: any) =>
                                    <option key={location.Name} value={location.Name}>
                                        {location.Name}
                                    </option>
                                )
                            }
                        </Input>
                        <FormFeedback style={{ textAlign: "right" }}>{this.state.UserDataValidation.DefaultLocation.isInvalid() ? this.state.UserDataValidation.DefaultLocation.Validation.Error : ""}</FormFeedback>
                    </InputGroup>
                    <InputGroup className="my-3" >
                        <InputGroupAddon addonType="prepend" >
                            <InputGroupText>Role</InputGroupText>
                        </InputGroupAddon>
                        <Input type={"select"} valid={this.state.UserDataValidation.UserRole.isValid()} invalid={this.state.UserDataValidation.UserRole.isInvalid()} onChange={(e) => this.updateUserData(e, "UserRole")} value={this.state.UserData.UserRole}>
                            <option key="default" hidden>
                                {this.props.resources.PleaseSelectARole}
                            </option >
                            {
                                userRoles(this.props.resources, this.props.isSuperUser).map((role) =>
                                    <option key={role.key} value={role.text}>
                                        {role.text}
                                    </option>
                                )
                            }
                        </Input>
                        <FormFeedback style={{ textAlign: "right" }}>{this.state.UserDataValidation.UserRole.isInvalid() ? this.state.UserDataValidation.UserRole.Validation.Error : ""}</FormFeedback>
                    </InputGroup>

                    {this.state.ApplicationValidation.isInvalid() && <FormFeedback style={{ display: "block"}}>{this.state.ApplicationValidation.Error}</FormFeedback>}
                </div>);
            case AddUserEventContentState.Pending:
                return (<CustomSpinner />);
            case AddUserEventContentState.Success:
                return (<div>
                    <Row className="text-success mb-2">
                        <Col />
                        <Col xs="auto" >
                            <FontAwesomeIcon size="6x" icon={faCheckCircle} />
                        </Col>
                        <Col />
                    </Row>
                    <Row>
                        <Col />
                        <Col xs="auto" >
                            {this.props.resources.AddUserSuccessMessage}
                        </Col>
                        <Col />
                    </Row>
                </div>);

            case AddUserEventContentState.Error:
                return (<div>
                    <Row className="text-danger mb-2">
                        <Col />
                        <Col xs="auto" >
                            <FontAwesomeIcon size="6x" icon={faTimesCircle} />
                        </Col>
                        <Col />
                    </Row>
                    <Row>
                        <Col />
                        <Col xs="auto" >
                            {this.error.detail || this.props.resources.AnErrorHasOccurred}
                        </Col>
                        <Col />
                    </Row>
                </div>);
        }
    };

    render() {
        return this.stateBasedRender(this.state.status);
    }
}